var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTimeAttendance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 33,
    viewBox: "0 0 42 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2503_1460)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.64709 6.33447V25.4744C1.64709 27.7279 3.46456 29.5546 5.70676 29.5546H31.9711C34.2133 29.5546 36.0307 27.7279 36.0307 25.4744V6.33447H1.64709Z",
    stroke: "#231F20",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.3456 1.34814H13.3354V6.24564H24.3456V1.34814Z",
    stroke: "#231F20",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.64709 20.6665H36.0307",
    stroke: "#231F20",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.2032 18.1582H14.478V23.7804H23.2032V18.1582Z",
    fill: "#106B46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.0727 32.8011C38.7895 32.8011 41.8025 29.7728 41.8025 26.0373C41.8025 22.3017 38.7895 19.2734 35.0727 19.2734C31.3558 19.2734 28.3428 22.3017 28.3428 26.0373C28.3428 29.7728 31.3558 32.8011 35.0727 32.8011Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.1701,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.6489 25.9814C28.6489 29.5122 31.5068 32.3812 35.0166 32.3812C38.5264 32.3812 41.3843 29.5089 41.3843 25.9814C41.3843 22.4539 38.5264 19.5815 35.0166 19.5815C31.5068 19.5815 28.6489 22.4506 28.6489 25.9814ZM40.199 25.4023H39.7941C39.4747 25.4023 39.2179 25.6604 39.2179 25.9814C39.2179 26.3024 39.4747 26.5605 39.7941 26.5605H40.199C39.9323 28.9894 38.0095 30.9219 35.5928 31.1899V30.7829C35.5928 30.4619 35.336 30.2038 35.0166 30.2038C34.6973 30.2038 34.4404 30.4619 34.4404 30.7829V31.1899C32.0237 30.9219 30.1009 28.9894 29.8342 26.5605H30.2392C30.5586 26.5605 30.8154 26.3024 30.8154 25.9814C30.8154 25.6604 30.5586 25.4023 30.2392 25.4023H29.8342C30.1009 22.9734 32.0237 21.0409 34.4404 20.7728V21.1798C34.4404 21.5008 34.6973 21.7589 35.0166 21.7589C35.336 21.7589 35.5928 21.5008 35.5928 21.1798V20.7728C38.0095 21.0409 39.9323 22.9734 40.199 25.4023Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.122 24.8496C35.0891 24.8463 35.0529 24.8396 35.0199 24.8396C34.3944 24.8396 33.8873 25.3492 33.8873 25.978C33.8873 26.6067 34.3944 27.1163 35.0199 27.1163C35.6455 27.1163 36.1526 26.6067 36.1526 25.978C36.1526 25.8158 36.1196 25.6636 36.0571 25.5246L37.5815 23.4134C37.7692 23.1553 37.7099 22.7913 37.4531 22.606C37.1963 22.4174 36.8341 22.4736 36.6497 22.735L35.122 24.8496Z",
    fill: "#231F20"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2503_1460"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 33,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeAttendance);
export default __webpack_public_path__ + "static/media/timeAttendance.61849873bffc67bb7e0ccd7e101f997f.svg";
export { ForwardRef as ReactComponent };